import { tokenState } from './getNewToken';
export const getAccessTokenFromMemory = () => {
    const { accessToken, expiryDate } = tokenState;
    const now = new Date();
    if (!accessToken || !expiryDate || expiryDate < now.getTime()) {
        return undefined;
    }
    return accessToken;
};
//# sourceMappingURL=getAccessTokenFromMemory.js.map